import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { AppTitlePage } from '../../components/AppTitlePage'
import { AppBtnColor } from '../../components/btn/AppBtn'

import { IPopup } from '../CategoriesPage/CategoriesPage'
import { AppFilterInput } from '../../components/AppInput/AppFilterInput'
import { AppTable } from '../../components/AppTable/AppTable'
import { useGetTagsListQuery } from '../../core/api/TagsApi'
import { useParamsControl } from '../../utils/useParamsControl'
import { ITag, ITagsRequestDto } from '../../core/api/dto/TagsDto'
import { AddTagsPopup } from './components/AddTagsPopup'
import { useDeleteTags } from './hooks/useDeleteTags'
// import { AppFilterEdgeServersList } from '../../../entities/AppFilterEdgeServersList/AppFilterEdgeServersList'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'
import { AppDeletePopup } from 'entities/AppDeletePopup/AppDeletePopup'
import { createQueryStringSmart } from 'utils/createQueryString'
import { useSearchParams } from 'react-router-dom'

const headerData = [{ title: 'Название', colWidth: '95%', sort: 'name' }]

export const TagsPage = () => {
  const pageParams = useParamsControl<ITagsRequestDto, keyof ITagsRequestDto>({
    withPagination: true,
    whiteList: ['search', 'ordering'],
  })

  const [openCreatePopup, setOpenCreatePopup] = useState<IPopup>({
    active: false,
    id: null,
  })

  const { data: tagList } = useGetTagsListQuery(
    {
      ...pageParams,
      ordering: pageParams?.ordering ? pageParams?.ordering : 'is_archived',
    },
    {
      skip: !pageParams,
    },
  )

  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [tableData, setTableData] = useState<ITag[]>([])

  const {
    deletePopup,
    closeDeletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
  } = useDeleteTags(chooseItems, setChooseItems)

  const openEditPopupHandler = useCallback(
    (id: number) => setOpenCreatePopup({ id, active: true }),
    [],
  )

  const closePopupHandler = useCallback(
    () => setOpenCreatePopup({ id: null, active: false }),
    [],
  )

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
  ]
  const actions = useMemo(
    () => [
      {
        btnTitle: 'Добавить хэштег',
        btnIco: 'add',
        onClick: () =>
          setOpenCreatePopup((prevState) => ({ ...prevState, active: true })),
        color: AppBtnColor.whiteOutlineViolet,
      },
    ],
    [],
  )

  if (!tagList) {
    return null
  }

  return (
    <React.Fragment>
      {openCreatePopup.active && (
        <AddTagsPopup id={openCreatePopup.id} closePopup={closePopupHandler} />
      )}
      {deletePopup && (
        <AppDeletePopup onClose={closeDeletePopup} onDelete={onDeleteHandler} />
      )}

      <div className="width-for-page-wrapper">
        <AppTitlePage title="Хэштеги" actions={actions} />
        <div className="col-7-width-from-1000">
          <div className="filter-block no-wrap mt-20">
            <AppFilterInput
              fullWidth
              searchParam={'search'}
              ico={'search'}
              label={'Поиск'}
              placeholder="Поиск: #"
            />
          </div>
          <AppTable
            data={tagList}
            headerData={headerData}
            chooseItems={chooseItems}
            chooseMode
            setChooseItems={setChooseItems}
            idName="tags"
            setTableData={setTableData}
            tableDataSelectors={[
              {
                renderItem: (item) => (
                  <div
                    className={`table-link ${
                      item.isArchived ? 'delete-item' : ''
                    }`}
                    onClick={() => openEditPopupHandler(item.id)}
                  >
                    {item.name}
                  </div>
                ),
              },
            ]}
            chooseActions={tableActions}
            additionalOrdering={'is_archived'}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
